export const GET_SIGNALR_TOKEN = '/api/Notification/GetSignalRToken';
export const COMMON_MESSAGES = {
  DATE_YYYY_MM_DD: 'YYYY-MM-DD',
  DATE_DD_MMM_YYYY: 'DD MMM YYYY',
  ERROR: 'Something went wrong, please contact to your system administrator.',
  MAX_LENGTH_100: 'Maximum length should be 100 characters',
  MAX_LENGTH_50: 'Maximum length should be 50 characters',
  MAX_LENGTH_20: 'Maximum length should be 20 characters',
  MAX_LENGTH_10: 'Maximum length should be 10 characters',
  ACTIVE: 'Are you sure you want to activate',
  INACTIVE: 'Are you sure you want to inactive',
  ALPHA_NUMERIC_ONLY: 'The value must contain only alphanumeric characters.',
};

export const PATTERN_ALPHA_NUMERIC_ONLY = /^[a-zA-Z0-9]+$/;
export const UK_TIME_ZONE = 'Europe/London';
